{
  "es": {
    "labels": {
      "true": "Sí",
      "false": "No",
      "null": "-",
      "and": "y",
      "hide": "Ocultar",
      "show": "Mostrar",
      "only": "Solo",
      "description": "Descripción",
      "unavailable": "no disponible",
      "selected": "Seleccionado",
      "actions": "Acciones",
      "enabled": "Habilitado",
      "disabled": "Deshabilitado",
      "collapse": "Contraer",
      "price": "Precio",
      "expand": "Expandir",
      "distance": "Distancia",
      "anonymous": "Anónimo",
      "toggleNavigation": "Alternar navegación",
      "enableYoutube": "Haz clic para habilitar videos de YouTube o clic derecho para copiar URL del video",
      "openInNewWindow": "Abrir en pantalla completa",
      "or": "o",
      "deselect": "Haz clic para deseleccionar",
      "networkStatusOffline": "Estado de red: Desconectado - Servicio no disponible",
      "groups": "Grupos",
      "classifications": "Clasificaciones",
      "features": {
        "stateOn": "Habilitado",
        "stateOff": "Deshabilitado",
        "stateConditional": "Condicional",
        "selfService": "Autoservicio",
        "selfServiceEnabled": "Los usuarios pueden activar/desactivar esta función",
        "selfServiceDisabled": "Los usuarios no pueden activar/desactivar esta función",
        "actors": "Actores",
        "groups": "Grupos",
        "noGroups": "No hay grupos habilitados para esta función.",
        "noActors": "No hay actores individuales habilitados para esta función.",
        "user": "Usuario",
        "fleet": "Flota",
        "actorType": "Tipo de actor",
        "percentageOfActors": "de actores",
        "percentageOfTime": "del tiempo",
        "currentState": "Estado actual",
        "toggle": "Alternar",
        "settingsIntro": "Habilite o deshabilite funciones experimentales para su cuenta. Estas funciones pueden estar incompletas o cambiar sin previo aviso.",
        "noFeaturesAvailable": "Actualmente no hay funciones de autoservicio disponibles.",
        "descriptions": {
          "tools_travel_times": "Mostrar tiempos de viaje estimados entre ubicaciones.",
          "tools_cargo_grids": "Mostrar visor interactivo de grilla de carga para naves.",
          "fleet_starmap": "Mostrar mapa estelar de Star Citizen en las páginas de miembros de flota."
        },
        "fleetSettingsIntro": "Habilite o deshabilite funciones para toda la flota. Todos los miembros ven lo que active aquí.",
        "fleetFeature": "Función de flota",
        "fleetFeatureInfo": "Activarla aquí la habilita solo para usted. Los administradores de su flota pueden habilitarla para toda la flota.",
        "toggleForSelf": "Activar solo para usted",
        "fleetFeatureGrantedShort": "Activado por la flota",
        "fleetFeatureGranted": "Su flota lo activó para todos los miembros, por lo que no se puede desactivar aquí.",
        "groupFeatureGrantedShort": "Activado por el grupo",
        "groupFeatureGranted": "Un grupo al que pertenece tiene esta función activada, por lo que no se puede desactivar aquí.",
        "groupFeatureGrantedFleet": "Un grupo al que pertenece esta flota tiene esta función activada, por lo que no se puede desactivar aquí.",
        "managedFeatureShort": "Gestionado",
        "managedFeature": "Esta función se activó para su cuenta y no se puede cambiar aquí.",
        "managedFeatureFleet": "Esta función se activó para esta flota y no se puede cambiar aquí.",
        "selfServiceUser": "Los usuarios pueden alternar",
        "selfServiceFleet": "Los admins de flota pueden alternar"
      },
      "oauthApplication": {
        "name": "Nombre de la aplicación",
        "clientId": "ID de cliente",
        "clientSecret": "Secreto de cliente",
        "redirectUri": "URI de redirección",
        "redirectUriHint": "Use una URI por línea.",
        "confidential": "Confidencial",
        "scopes": "Alcances",
        "scopesHint": "Si no se seleccionan alcances, se usarán los alcances predeterminados: %{scopes}"
      },
      "rsiRequestLogs": {
        "resolved": "Resuelto",
        "unresolved": "Sin resolver"
      },
      "oauthApplications": {
        "settingsIntro": "Administre sus aplicaciones OAuth. Estas aplicaciones pueden acceder a la API de FleetYards en nombre de los usuarios.",
        "name": "Nombre de la aplicación",
        "redirectUri": "URI de redirección",
        "confidential": "Confidencial",
        "clientId": "ID de cliente",
        "clientSecret": "Secreto de cliente",
        "scopes": "Alcances",
        "defaultScopes": "Alcances predeterminados",
        "confidentialShort": "Confidencial",
        "publicShort": "Público"
      },
      "fleetInviteToken": "Invitación de flota",
      "scDataVersion": "Versión del parche",
      "lastReload": "Última recarga",
      "createdAt": "Creado el",
      "updatedAt": "Actualizado el",
      "addToHangar": "Agregar al hangar",
      "home": {
        "search": "Buscar naves..."
      },
      "shop": {
        "rentalPrice": "alquiler",
        "sellPrice": "vende por",
        "buyPrice": "compra por"
      },
      "shopCommodity": {
        "item": "Artículo",
        "shop": "Tienda",
        "sellPrices": "Precios de venta",
        "buyPrices": "Precios de compra",
        "rentalPrices": "Precios de alquiler",
        "confirmed": "¿Confirmado?",
        "submittedBy": "Enviado por",
        "prices": {
          "label": "Precios",
          "rentalPrice": "alquiler",
          "averageRentalPrice": "alquiler (Ø)",
          "sellPrice": "vende por",
          "averageSellPrice": "vende por (Ø)",
          "buyPrice": "compra por",
          "averageBuyPrice": "compra por (Ø)",
          "rentalPrice1Day": "1 día por",
          "averageRentalPrice1Day": "1 día por (Ø)",
          "rentalPrice3Days": "3 días por",
          "averageRentalPrice3Days": "3 días por (Ø)",
          "rentalPrice7Days": "7 días por",
          "averageRentalPrice7Days": "7 días por (Ø)",
          "rentalPrice30Days": "30 días por",
          "averageRentalPrice30Days": "30 días por (Ø)"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "Nuevas naves en %{year}",
          "totalShips": "Total de naves",
          "totalMembers": "Total de miembros",
          "vehicles": "Naves en hangar",
          "wishlists": "Naves en lista de deseos",
          "shipOfTheMonth": "Nave del mes"
        },
        "modelsByClassification": "Naves por clasificación",
        "modelsBySize": "Naves por tamaño",
        "vehiclesByModel": "Naves por modelo (Top %{limit})",
        "modelsPerMonth": "Naves por mes",
        "modelsByManufacturer": "Naves por fabricante",
        "modelsByProductionStatus": "Naves por estado de producción",
        "vehiclesPerMonth": "Naves en hangar por mes",
        "topVehiclesByModel": "Top 10 naves en hangar",
        "shipsOfTheMonth": "Nave del mes",
        "crewDeficit": "Déficit de tripulación",
        "crewSurplus": "Excedente de tripulación",
        "membersByRole": "Miembros por rol"
      },
      "roadmap": {
        "selectWeek": "Seleccionar semana",
        "shipRoadmap": "Roadmap de naves",
        "releases": "Lanzamientos",
        "unscheduled": "Sin programar",
        "lastUpdate": "Última actualización",
        "released": "Lanzado",
        "recentlyUpdated": "Actualizado recientemente",
        "committed": "Comprometido",
        "lastVersion": {
          "active": {
            "false": "Elemento eliminado de la hoja de ruta",
            "true": "Elemento re-agregado a la hoja de ruta",
            "decreased": "Item was removed from the Roadmap",
            "increased": "Item was readded to the Roadmap"
          },
          "committed": "Item was marked as committed",
          "released": "Item was released to PU",
          "release": "Item moved from release %{old} to %{new}",
          "addedToRelease": "Item new in release %{release}"
        },
        "stories": {
          "one": "%{count} Story",
          "other": "%{count} Stories"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        }
      },
      "rsiRoadmap": "RSI Roadmap",
      "unknown": "Desconocido",
      "none": "-",
      "notAvailable": "N/A",
      "unknownModel": "%{slug} Unknown",
      "not-available": "N/A",
      "receiveSaleNotifications": "",
      "publicUrl": "URL pública",
      "name": "Nombre",
      "homepage": "Página principal",
      "discord": "Servidor de Discord",
      "youtube": "Canal de Youtube",
      "twitch": "Canal de Twitch",
      "guilded": "Servidor de Guilded",
      "3dView": "3D",
      "3dMap": "Map",
      "filter": "Filtro",
      "taxExcluded": "sin IVA",
      "hangar": "Hangar",
      "public": "Público",
      "hangarStats": "Estadísticas",
      "wishlist": "Lista de deseos",
      "fleetchart": "Gráfico de flota",
      "fleetchartApp": {
        "screenHeight": "Altura de pantalla",
        "viewpoint": "Punto de vista",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "Lateral",
          "top": "Superior",
          "angled": "Angular",
          "front": "Frontal"
        },
        "gridSize": "%{size} metro por cuadrícula",
        "mode": "Modo",
        "modeOptions": {
          "classic": "Clásico",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Estadísticas",
      "hangarMetrics": {
        "total": "Total",
        "totalMoney": "Money Value",
        "totalCredits": "Credits",
        "totalIngameValue": "Valor aUEC del hangar",
        "totalMinCrew": "Tripulación mín.",
        "totalMaxCrew": "Tripulación máx.",
        "totalCargo": "Carga total",
        "largestShip": "Nave más grande",
        "smallestShip": "Nave más pequeña",
        "averagePledgePrice": "Precio promedio de Pledge",
        "flightReady": "Listo para volar",
        "uniqueModels": "Modelos únicos",
        "manufacturerCount": "Fabricantes",
        "missingClassifications": "Roles faltantes",
        "wishlistTotalMoney": "Valor de Pledge de lista de deseos",
        "wishlistTotalCredits": "Valor en juego de lista de deseos"
      },
      "selectModel": "Seleccionar una nave",
      "findModel": "Escribe para buscar una nave",
      "find": "Escribe para buscar",
      "selectUser": "Seleccionar un usuario",
      "findUser": "Escriba para buscar un usuario",
      "selectFleet": "Seleccionar una flota",
      "findFleet": "Escriba para buscar una flota",
      "compare": {
        "removeModel": "Eliminar nave",
        "addModel": {
          "nullablePrompt": "Agregar una nave"
        },
        "enough": "Don't you think 8 Ships are enough? ;)"
      },
      "cargoRoutes": "Rutas de carga",
      "uecPerUnit": "aUEC / Unit",
      "au": "AU",
      "uec": "aUEC",
      "sell": "Vender",
      "buy": "Comprar",
      "yourFlagship": "Su nave insignia",
      "flagship": "Nave insignia",
      "fleet": {
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Flota",
        "fid": "ID de flota",
        "name": "Nombre",
        "logo": "Logo",
        "rsiSid": "SID",
        "description": "Descripción",
        "public": "Vista de flota pública",
        "publicFleet": "Flota pública",
        "publicStats": "Estadísticas públicas",
        "publicFleetStats": "Estadísticas de flota públicas",
        "discord": "Servidor de Discord",
        "guilded": "Servidor de Guilded",
        "homepage": "Página principal",
        "twitch": "Canal de Twitch",
        "youtube": "Canal de Youtube",
        "backgroundImage": "Imagen de fondo",
        "ts": "Servidor Teamspeak",
        "awaitingConfirmation": "Esperando confirmación de la flota",
        "members": {
          "primary": "¿Flota principal?",
          "hideShips": "¿Ocultar sus naves para esta flota?",
          "shipsFilter": {
            "label": "¿Qué naves deben agregarse a la flota?",
            "nullablePrompt": "No se seleccionó ninguna opción",
            "field": "Selección de naves",
            "values": {
              "all": "Todas las naves",
              "hangar_group": "Todas las naves en un grupo de hangar dado",
              "hide": "Sin naves"
            }
          },
          "hangarGroupId": {
            "field": "Grupo de hangar",
            "label": "Especifique un grupo de hangar",
            "nullablePrompt": "No se seleccionó ningún grupo"
          },
          "total": "Total: %{count}",
          "joined": "Unido el",
          "invited": "Invitado",
          "invitedAt": "Invitado / Solicitado el",
          "requested": "Membresía solicitada",
          "declined": "Rechazado",
          "pending": "Invitaciones y solicitudes pendientes",
          "accepted": "Miembros",
          "declinedMembers": "Rechazado",
          "role": "Rol",
          "roles": {
            "admin": "Admin",
            "officer": "Oficial",
            "member": "Miembro"
          },
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord"
        },
        "roles": {
          "permanent": "Permanente",
          "privilegeGroups": {
            "fleet": "Flota",
            "memberships": "Miembros",
            "invites": "Invitaciones",
            "vehicles": "Vehículos",
            "roles": "Roles"
          },
          "privileges": {
            "fleet:update": "Actualizar flota",
            "fleet:update:images": "Actualizar imágenes",
            "fleet:update:description": "Actualizar descripción",
            "fleet:delete": "Eliminar flota",
            "fleet:manage": "Administrar flota",
            "fleet:memberships:read": "Ver miembros",
            "fleet:memberships:create": "Invitar miembros",
            "fleet:memberships:update": "Actualizar miembros",
            "fleet:memberships:delete": "Eliminar miembros",
            "fleet:memberships:manage": "Administrar miembros",
            "fleet:invites:read": "Ver invitaciones",
            "fleet:invites:create": "Crear invitaciones",
            "fleet:invites:delete": "Eliminar invitaciones",
            "fleet:invites:manage": "Administrar invitaciones",
            "fleet:vehicles:read": "Ver vehículos",
            "fleet:vehicles:create": "Agregar vehículos",
            "fleet:vehicles:update": "Actualizar vehículos",
            "fleet:vehicles:delete": "Eliminar vehículos",
            "fleet:vehicles:manage": "Administrar vehículos",
            "fleet:roles:read": "Ver roles",
            "fleet:roles:create": "Crear roles",
            "fleet:roles:update": "Actualizar roles",
            "fleet:roles:delete": "Eliminar roles",
            "fleet:roles:manage": "Administrar roles"
          }
        },
        "inviteUrls": {
          "noLimit": "No limit",
          "noExpiration": "Never expires",
          "usesLeft": "%{count} uses left",
          "used": "Usado %{count} veces",
          "usedOfLimit": "%{count} de %{limit} usados",
          "expiresIn": "Expires in %{time}",
          "expired": "Expired",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 día",
            "7_days": "7 days"
          },
          "limitOptions": {
            "infinite": "No limit",
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses"
          }
        }
      },
      "hangarGroup": {
        "name": "Nombre",
        "color": "Color",
        "sort": "Orden",
        "public": "¿Mostrar en hangar público?"
      },
      "source": "Fuente",
      "model": {
        "hidden": "¿Oculto?",
        "active": "¿Activo?",
        "inGame": "¿En el juego?",
        "adiMap": "¿Mapa ADI?",
        "ground": "¿Vehículo terrestre?",
        "productionNote": "Nota de producción",
        "rsiId": "RSI ID",
        "length": "Longitud",
        "beam": "Manga",
        "height": "Altura",
        "scIdentifier": "SC Identifier",
        "price": "Precio",
        "pledgePrice": "Precio de Pledge",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Masa",
        "minCrew": "Tripulación mín.",
        "maxCrew": "Tripulación máx.",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Velocidad máx.",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Carga",
        "cargoHolds": "Bodegas de carga",
        "hydrogenFuelTankSize": "Tamaño del tanque de hidrógeno",
        "hydrogenFuelTanks": "Tanques de combustible de hidrógeno",
        "quantumFuelTankSize": "Tamaño del tanque Quantum",
        "quantumFuelTanks": "Tanques de combustible Quantum",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Guiñada potenciada",
        "pitchBoosted": "Cabeceo potenciado",
        "rollBoosted": "Balanceo potenciado",
        "variants": "Variantes",
        "manufacturer": "Fabricante",
        "loaners": "Prestados",
        "paints": "Pinturas",
        "modules": "Módulos",
        "modulePackages": "Paquetes de módulos",
        "upgrades": "Kits de mejora",
        "brochure": "Folleto",
        "holo": "Holo",
        "angledView": "Vista angular",
        "angledViewColored": "Vista angular a color",
        "sideView": "Vista lateral",
        "sideViewColored": "Vista lateral a color",
        "frontView": "Vista frontal",
        "frontViewColored": "Vista frontal a color",
        "topView": "Vista superior",
        "topViewColored": "Vista superior a color",
        "onSale": "En venta",
        "salesPage": "Página de venta",
        "addons": "Módulos y kits de mejora",
        "storeImage": "Imagen de tienda",
        "wiki": "Star Citizen Wiki",
        "baseModel": "Modelo base",
        "fleetchartOffsetLength": "Desfase de longitud del gráfico de flota",
        "fleetchartOffsetBeam": "Desfase de manga del gráfico de flota",
        "productionStatus": {
          "in-production": "En producción",
          "in-concept": "En concepto",
          "ready": "Listo para hangar",
          "flight-ready": "Listo para volar",
          "announced": "Anunciado"
        }
      },
      "models": {
        "extraColumns": "Columnas",
        "table": {
          "columns": {
            "storeImage": "Imagen",
            "storeImageWide": "Imagen ancha",
            "rsiStoreImage": "Imagen RSI",
            "rsiStoreImageWide": "Imagen RSI ancha",
            "angledView": "Imagen 3D",
            "angledViewWide": "Imagen 3D ancha",
            "rsiId": "RSI ID",
            "hidden": "Oculto",
            "active": "Activo",
            "createdAt": "Creado el",
            "updatedAt": "Actualizado el",
            "manufacturerName": "Fabricante",
            "length": "Longitud",
            "beam": "Manga",
            "height": "Altura",
            "mass": "Masa",
            "cargo": "Carga",
            "quantumFuelTankSize": "Combustible Quantum",
            "hydrogenFuelTankSize": "Combustible de hidrógeno",
            "minCrew": "Tripulación",
            "maxCrew": "Tripulación máx.",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Velocidad máx.",
            "groundMaxSpeed": "Velocidad terrestre",
            "focus": "Enfoque",
            "productionStatus": "Estado de producción",
            "price": "Precio",
            "pledgePrice": "Precio de Pledge"
          }
        }
      },
      "metrics": {
        "info": "Info",
        "levels": "Niveles",
        "views": "Vistas",
        "base": "Base",
        "crew": "Tripulación",
        "speed": "Velocidad",
        "cargo": "Carga",
        "hardpoints": "Puntos de montaje",
        "missileOptions": "Opciones de misiles (si disponibles)",
        "topView": "Top View"
      },
      "manufacturer": {
        "longName": "Nombre completo",
        "code": "Código",
        "logo": "Logo",
        "icon": "Icono (archivos del juego)",
        "iconOverridden": "Icono (sobrescrito)",
        "scRef": "SC Ref"
      },
      "itemPrice": {
        "price": "Precio",
        "location": "Ubicación",
        "locationUrl": "URL de ubicación"
      },
      "video": {
        "url": "URL",
        "videoType": "Tipo"
      },
      "modelModule": {
        "name": "Nombre",
        "description": "Descripción",
        "price": "Precio",
        "pledgePrice": "Precio Pledge",
        "productionStatus": "Estado de Producción",
        "scKey": "SC Key",
        "storeImage": "Imagen de Tienda",
        "active": "¿Activo?",
        "hidden": "¿Oculto?"
      },
      "dock": {
        "name": "Nombre",
        "dockType": "Tipo de muelle",
        "shipSize": "Tamaño de nave"
      },
      "modelHardpoint": {
        "name": "Nombre",
        "key": "Clave",
        "source": "Fuente",
        "group": "Grupo",
        "hardpointType": "Tipo",
        "size": "Tamaño",
        "category": "Categoría",
        "subCategory": "Subcategoría",
        "details": "Detalles",
        "mount": "Montaje",
        "itemSlots": "Ranuras de objetos",
        "loadoutIdentifier": "Identificador de configuración"
      },
      "modelHardpointLoadout": {
        "name": "Nombre"
      },
      "modelUpgrade": {
        "name": "Nombre",
        "description": "Descripción",
        "pledgePrice": "Precio de Pledge",
        "active": "¿Activo?",
        "hidden": "¿Oculto?"
      },
      "modelModulePackage": {
        "name": "Nombre",
        "description": "Descripción",
        "pledgePrice": "Precio de Pledge",
        "modules": "Módulos",
        "active": "¿Activo?",
        "hidden": "¿Oculto?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotación (°)"
      },
      "modelLoaner": {
        "hidden": "¿Oculto?",
        "loanerModel": "Modelo prestado"
      },
      "modelPaint": {
        "hidden": "¿Oculto?",
        "active": "¿Activo?",
        "onSale": "En venta",
        "pledgePrice": "Precio de Pledge",
        "productionStatus": "Estado de producción",
        "productionNote": "Nota de producción"
      },
      "component": {
        "size": "Size: %{size}",
        "grade": "Grado",
        "hidden": "¿Oculto?",
        "componentClass": "Clase de componente",
        "componentType": "Tipo de componente",
        "componentSubType": "Subtipo de componente",
        "itemType": "Tipo de objeto",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "hardpoint": {
        "legend": {
          "headline": "Leyenda",
          "slotTaken": "Slot ocupado",
          "slotAvailable": "Slot disponible"
        },
        "size": "Tamaño",
        "rackSize": "Tamaño de rack",
        "details": "Detalles",
        "group": "Grupo",
        "thrusters": {
          "thrust": "Empuje",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix"
          }
        },
        "sources": {
          "game_files": "Archivos del juego",
          "ship_matrix": "Ship Matrix"
        },
        "fuelTanks": {
          "hydrogen": "Tanque de combustible de hidrógeno",
          "quantum": "Tanque de combustible Quantum"
        },
        "jumpDrive": "Motor de salto",
        "maxContainerSize": "Tamaño máx. de contenedor",
        "groups": {
          "avionic": "Aviónica",
          "system": "Sistemas",
          "propulsion": "Propulsión",
          "thruster": "Propulsor",
          "weapon": "Armas",
          "other": "Otros",
          "auxiliary": "Auxiliar",
          "seat": "Asientos"
        },
        "types": {
          "radar": "Radar",
          "computers": "Computadoras",
          "power_plants": "Plantas de energía",
          "coolers": "Enfriadores",
          "shield_generators": "Generadores de escudo",
          "fuel_intakes": "Tomas de combustible",
          "fuel_tanks": "Tanques de combustible",
          "quantum_drives": "Motores Quantum",
          "jump_modules": "Módulos de salto",
          "jumpdrive": "Módulos de salto",
          "quantum_fuel_tanks": "Tanques de combustible Quantum",
          "main_thrusters": "Propulsores principales",
          "maneuvering_thrusters": "Propulsores de maniobra",
          "weapons": "Armas",
          "turrets": "Torretas",
          "missiles": "Misiles",
          "utility_items": "Objetos de utilidad",
          "utility": "Objetos de utilidad",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Seleccionar módulo —",
        "selectModule": "Seleccionar módulo",
        "clearModule": "Borrar selección",
        "categories": {
          "radar": "Radar",
          "armor": "Blindaje",
          "relay": "Relé",
          "countermeasures": "Contramedidas",
          "lifesupport": "Soporte vital",
          "selfdestruct": "Autodestrucción",
          "batteries": "Baterías",
          "computers": "Computadoras",
          "powerplant": "Plantas de energía",
          "cooler": "Enfriadores",
          "module": "Módulos",
          "shieldgenerator": "Generadores de escudo",
          "fuel_intakes": "Tomas de combustible",
          "fueltanks": "Tanques de combustible",
          "quantumdrive": "Motores Quantum y módulos de salto",
          "jump_modules": "Módulos de salto",
          "jumpdrive": "Módulos de salto",
          "quantum_fuel_tanks": "Tanques de combustible Quantum",
          "main_thrusters": "Propulsores principales",
          "maneuvering_thrusters": "Propulsores de maniobra",
          "retro_thrusters": "Propulsores retro",
          "vtol_thrusters": "Propulsores VTOL",
          "weapons": "Armas",
          "weapon_mounts": "Soportes de armas",
          "turret": "Torretas",
          "missiles": "Misiles",
          "missile_racks": "Racks de misiles",
          "utility_items": "Objetos de utilidad",
          "utility": "Objetos de utilidad",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Estación de llenado de salvamento",
          "cargogrid": "Grilla de carga",
          "seat": "Asientos"
        }
      },
      "blank": {
        "propulsion": "Sin propulsión presente",
        "ordnance": "Sin armamento presente",
        "modular": "Sin módulo presente",
        "avionics": "Sin aviónica presente",
        "fleetInvites": "Sin invitaciones presentes",
        "shopCommodities": "No hay mercancías disponibles",
        "userShips": "Your Hangar is currently Empty. To Add Ships / Vehicles to Your Hangar click the following Icon on Any Ship in the Database:"
      },
      "user": {
        "rsiHandle": "Handle",
        "location": "Ubicación",
        "currentSystem": "Sistema estelar actual",
        "tester": "¿Tester?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Correo electrónico no confirmado",
        "saleNotify": "Deseo recibir notificaciones de ventas",
        "publicHangar": "Hangar público habilitado",
        "publicHangarLoaners": "Mostrar indicación de préstamos en hangar público",
        "publicHangarStats": "Estadísticas de hangar público habilitadas",
        "publicWishlist": "Lista de deseos pública habilitada",
        "hideOwner": "Ocultar propiedad para flotas",
        "lastActiveAt": "Última actividad",
        "confirmedAt": "Confirmado el"
      },
      "adminUser": {
        "superAdmin": "Super administrador",
        "passwordConfirmation": "Confirmación de contraseña"
      },
      "vehicle": {
        "name": "Nombre",
        "states": "Estados",
        "serial": "Serie",
        "owner": "comandado por",
        "flagship": "Nave insignia",
        "wanted": "Deseado",
        "loaner": "Prestado",
        "public": "Visible públicamente",
        "fullPublic": "Visible públicamente incluyendo nombre",
        "publicShort": "Público",
        "nameVisible": "Visible públicamente",
        "saleNotify": "Deseo recibir notificaciones de ventas",
        "hangarGroups": "Grupos",
        "selectGroup": "Seleccionar un grupo",
        "modelPaintSelect": {
          "nullablePrompt": "Seleccionar una pintura",
          "label": "Pintura"
        },
        "bulkGroupEdit": {
          "hint": "¡Los grupos existentes serán reemplazados!"
        },
        "hasLoaners": "Prestados",
        "boughtViaSelect": {
          "label": "Comprado mediante"
        }
      },
      "image": {
        "active": "¿Activo?",
        "background": "¿Usar como fondo?",
        "caption": "Descripción",
        "enabled": "¿Habilitado?",
        "file": "Archivo de imagen",
        "global": "¿Global?",
        "delete": "Eliminar",
        "start": "Iniciar",
        "cancel": "Cancelar",
        "processing": "Procesando...",
        "error": "Error",
        "name": "Nombre",
        "size": "Tamaño de archivo",
        "dropzone": "Soltar imágenes aquí",
        "cancelUpload": "Cancelar subida",
        "startUpload": "Iniciar subida",
        "selectImages": "Agregar imágenes...",
        "selectFolder": "Agregar una carpeta..."
      },
      "signup": {
        "link": "¿No tiene una cuenta?",
        "privacyPolicy": "Al crear una cuenta en FleetYards, acepta nuestra"
      },
      "privacyPolicy": "Política de privacidad",
      "login": "Nombre de usuario o correo electrónico",
      "username": "Nombre de usuario",
      "twoFactorCode": "Código de dos factores",
      "confirmationCode": "Código de confirmación",
      "email": "Correo electrónico",
      "avatar": "Avatar",
      "alreadyRegistered": "¿Ya tiene una cuenta?",
      "currentPassword": "Contraseña actual",
      "password": "Contraseña",
      "passwordConfirmation": "Confirmación de contraseña",
      "rememberMe": "Recordarme",
      "emptyList": "No hay %{name} presente",
      "all": "Todos",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted."
      },
      "filters": {
        "components": {
          "name": "Nombre",
          "itemType": "Tipo de objeto",
          "componentClass": "Clase de componente",
          "buyPriceGt": "Precio de compra >=",
          "buyPriceLt": "Precio de compra <=",
          "sellPriceGt": "Precio de venta >=",
          "sellPriceLt": "Precio de venta <=",
          "storeImageBlank": "¿Sin imagen de tienda?"
        },
        "shops": {
          "name": "Nombre",
          "type": "Tipo",
          "celestialObject": "Objeto celeste",
          "model": "Nave",
          "equipment": "Equipamiento",
          "component": "Componente",
          "commodity": "Mercancía",
          "commodityType": "Tipo de mercancía",
          "starsystem": "Sistema estelar",
          "station": "Estación"
        },
        "shopCommodities": {
          "commodityType": "Tipo de mercancía",
          "station": "Estación",
          "shopId": "Tienda",
          "equipment": "Equipamiento",
          "component": "Componente",
          "componentItemTypeFilter": "Component Item Types",
          "equipmentItemTypeFilter": "Equipment Item Types",
          "equipmentTypeFilter": "Tipo de equipamiento",
          "equipmentSlotFilter": "Equipment Slot",
          "commodity": "Mercancía",
          "model": "Nave",
          "name": "Nombre"
        },
        "shopItems": {
          "category": "Categoría",
          "subCategory": "Subcategoría",
          "name": "Nombre",
          "manufacturer": "Fabricante",
          "minPrice": "min. Price",
          "maxPrice": "max. Price"
        },
        "stations": {
          "name": "Nombre",
          "celestialObject": "Objeto celeste",
          "starsystem": "Sistema estelar",
          "type": "Tipo de estación",
          "shops": "Tiendas",
          "docks": "Muelles",
          "habs": "¿Habitación?",
          "cargoHub": "¿Centro de carga?",
          "refinery": "¿Estación de refinería?"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Precio <=",
          "priceGt": "Precio >=",
          "wanted": "Deseado",
          "hidden": "Oculto",
          "public": "Público",
          "group": "Grupo",
          "loaner": "Prestados",
          "boughtVia": "¿Comprado mediante?"
        },
        "tradeRoutes": {
          "sortBy": "Sort by",
          "sortByValues": {
            "percent": "Max. Percent",
            "profit": "Max. Profit"
          },
          "cargoShip": "With Cargoship?",
          "origin": "From?",
          "destination": "To?",
          "excludeCommodityType": "Exclude Commodity Type",
          "originCelestialObject": "Origin Celestial Object",
          "destinationCelestialObject": "Destination Celestial Object",
          "originStarsystem": "Origin Starsystem",
          "destinationStarsystem": "Destination Starsystem"
        },
        "models": {
          "name": "Nombre",
          "shipRole": "Rol de nave",
          "classification": "Clasificación",
          "focus": "Enfoque",
          "manufacturer": "Fabricante",
          "onSale": "En venta",
          "size": "Tamaño",
          "dockSize": "Tamaño de muelle",
          "price": "Precio",
          "pledgePrice": "Precio de Pledge",
          "productionStatus": "Estado de producción",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Precio <=",
          "priceGt": "Precio >=",
          "willItFit": "Will it Fit?",
          "withCargo": "¿Con carga?",
          "scIdentifierBlank": "¿Sin identificador SC?",
          "fleetchartImageBlank": "¿Sin imagen de gráfico de flota?",
          "holoBlank": "¿Sin Holo?",
          "frontViewBlank": "¿Sin imagen de vista frontal?",
          "topViewColoredBlank": "¿Sin imagen de vista superior a color?"
        },
        "modelModules": {
          "name": "Nombre"
        },
        "manufacturers": {
          "name": "Nombre",
          "withModels": "Con modelos",
          "logoBlank": "Sin logo"
        },
        "images": {
          "station": "Estación",
          "model": "Nave"
        },
        "users": {
          "search": "Buscar",
          "username": "Nombre de usuario",
          "email": "Correo electrónico",
          "rsiHandle": "Handle de RSI"
        },
        "fleets": {
          "name": "Nombre",
          "fid": "FID",
          "member": "Miembro",
          "members": {
            "role": "Rol",
            "state": "Estado",
            "acceptedAtGt": "Unido desde",
            "acceptedAtLt": "Unido hasta",
            "invitedAtGt": "Invitado desde",
            "invitedAtLt": "Invitado hasta",
            "requestedAtGt": "Solicitado desde",
            "requestedAtLt": "Solicitado hasta",
            "declinedAtGt": "Rechazado desde",
            "declinedAtLt": "Rechazado hasta"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          }
        },
        "manufacturer": "Fabricante",
        "commodities": {
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "Precio de compra >=",
          "buyPriceLt": "Precio de compra <=",
          "sellPriceGt": "Precio de venta >=",
          "sellPriceLt": "Precio de venta <=",
          "storeImageBlank": "¿Sin imagen de tienda?"
        },
        "equipment": {
          "name": "Name",
          "equipmentType": "Equipment Type",
          "itemType": "Item Type",
          "weaponClass": "Weapon Class",
          "slot": "Slot",
          "buyPriceGt": "Precio de compra >=",
          "buyPriceLt": "Precio de compra <=",
          "sellPriceGt": "Precio de venta >=",
          "sellPriceLt": "Precio de venta <=",
          "storeImageBlank": "¿Sin imagen de tienda?"
        }
      },
      "station": {
        "docks": "Muelles",
        "location": "Ubicación",
        "type": "Tipo",
        "habitation": "Habitación",
        "habs": "Habitaciones",
        "shops": "Tiendas",
        "locationPrefix": {
          "default": "on",
          "asteriod": "on asteroid near",
          "orbit": "in orbit around"
        },
        "locationSuffix": "near %{location}"
      },
      "tradeRoutes": {
        "buy": "Buy for: %{uec}",
        "sell": "Sell for: %{uec}",
        "cargoShip": "for %{cargo} SCU",
        "sortByPercent": "Sort by Percent",
        "sortByProfit": "Sort by Profit",
        "sortByStation": "Sort by Station",
        "showAveragePrices": "Display average Prices",
        "showLatestPrices": "Display latest Prices"
      },
      "hardpoints": {
        "prefix": "Probar configuraciones con",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "Métricas basadas en las fórmulas de"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Seleccionar una nave"
      },
      "addAddon": {
        "nullablePrompt": ""
      },
      "table": {
        "selected": "%{count} seleccionados"
      },
      "commodityPrice": {
        "shopId": "Tienda",
        "station": "Estación",
        "commodityItemType": "Tipo de mercancía",
        "commodityItemId": "Artículo de mercancía",
        "item": "ShopCommodity",
        "price": "Precio",
        "type": "Tipo",
        "shop": "Tienda",
        "submittedBy": "Enviado por"
      },
      "syncExtension": {
        "warnings": "Avisos",
        "status": {
          "started": "Importación iniciada...",
          "finished": "Importación finalizada",
          "failed": "¡Importación fallida!"
        },
        "processSteps": {
          "fetchHangar": "Obteniendo datos del hangar RSI",
          "submitData": "Enviando datos al backend de Fleetyards.net"
        },
        "sessionStatus": "Estado de sesión RSI",
        "checkIdentity": "Verificar sesión RSI",
        "identityStatus": {
          "pending": "Comprobando...",
          "notFound": "no encontrado",
          "connected": "conectado"
        },
        "platforms": {
          "chrome": "Google Chrome",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Páginas",
          "all": "Todos los objetos de Pledge",
          "ships": "Naves",
          "components": "Módulos",
          "skins": "Pinturas",
          "upgrades": "Mejoras"
        },
        "importedItems": {
          "importedVehicles": "Naves agregadas",
          "foundVehicles": "Naves encontradas",
          "movedVehiclesToWanted": "Naves movidas a lista de deseos",
          "missingModels": "Naves no encontradas",
          "importedComponents": "Componentes agregados",
          "foundComponents": "Componentes encontrados",
          "missingComponents": "Componentes no encontrados",
          "missingComponentVehicles": "No se encontró nave coincidente para componentes",
          "importedUpgrades": "Mejoras agregadas",
          "foundUpgrades": "Mejoras encontradas",
          "missingUpgrades": "Mejoras no encontradas",
          "missingUpgradeVehicles": "No se encontró nave coincidente para mejoras",
          "new": "New",
          "updated": "Updated",
          "movedToWanted": "Moved to Wishlist",
          "missing": "Unable to Import"
        }
      },
      "cargoGridViewer": {
        "capacity": "Capacidad",
        "maxContainerSize": "Contenedor máx.",
        "packed": "Empaquetado",
        "totalCargo": "Carga total",
        "didNotFit": "No cabe",
        "openInTool": "Abrir en la herramienta de grilla de carga",
        "myHangar": "Mostrar solo mis naves",
        "filterShips": "Filtrar naves por tamaño de contenedor",
        "addShip": "Add Ship",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "admin": {
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Usuarios en línea",
            "totalUsers": "Usuarios totales",
            "totalShips": "Naves totales",
            "newShipsInYear": "Naves nuevas en %{year}",
            "totalFleets": "Flotas totales"
          }
        },
        "modelHardpoint": {
          "loadouts": "Configuraciones"
        }
      },
      "hangarTable": {
        "extraColumns": "Columnas",
        "columns": {
          "storeImage": "Imagen",
          "storeImageWide": "Imagen ancha",
          "angledView": "Imagen 3D",
          "angledViewWide": "Imagen 3D ancha",
          "modelManufacturerName": "Fabricante",
          "modelLength": "Longitud",
          "modelBeam": "Manga",
          "modelHeight": "Altura",
          "modelMass": "Masa",
          "modelCargo": "Carga",
          "modelMinCrew": "Tripulación",
          "modelMaxCrew": "Tripulación máx.",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Velocidad máx.",
          "modelGroundMaxSpeed": "Velocidad terrestre",
          "modelFocus": "Enfoque",
          "modelProductionStatus": "Estado de producción",
          "modelPrice": "Precio",
          "modelPledgePrice": "Precio de Pledge"
        }
      },
      "fleetTable": {
        "extraColumns": "Columnas",
        "columns": {
          "storeImage": "Imagen",
          "storeImageWide": "Imagen ancha",
          "angledView": "Imagen 3D",
          "angledViewWide": "Imagen 3D ancha",
          "modelManufacturerName": "Fabricante",
          "modelLength": "Longitud",
          "modelBeam": "Manga",
          "modelHeight": "Altura",
          "modelMass": "Masa",
          "modelCargo": "Carga",
          "modelMinCrew": "Tripulación",
          "modelMaxCrew": "Tripulación máx.",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Velocidad máx.",
          "modelGroundMaxSpeed": "Velocidad terrestre",
          "modelProductionStatus": "Estado de producción",
          "modelPrice": "Precio",
          "modelPledgePrice": "Precio de Pledge",
          "owner": "Propietario"
        }
      },
      "erkul": {
        "prefix": "Tryout Loadouts with",
        "link": "Erkul's DPS Calculator"
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "inProgress": "in progress",
        "drafts": "drafts",
        "noInventories": "No inventories yet.",
        "noRequests": "No requests found.",
        "noItems": "No entries in this inventory.",
        "entriesCount": "entries",
        "comments": "comments",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "fulfilled": "Fulfilled",
        "itemFulfilled": "Fulfilled",
        "itemPending": "Pending",
        "requestTitle": "Title",
        "description": "Description",
        "requestType": "Type",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "approvedBy": "Approved by",
        "fulfilledBy": "Fulfilled by",
        "addComment": "Write a comment...",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "approved": "Approved",
          "in_progress": "In Progress",
          "fulfilled": "Fulfilled",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "supply": "Supply",
          "outfitting": "Outfitting",
          "general": "General"
        },
        "priorities": {
          "routine": "Routine",
          "standard": "Standard",
          "urgent": "Urgent",
          "critical": "Critical"
        },
        "searchInventories": "Search inventories...",
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityShort": "Quality",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "por encima de la capacidad de carga",
        "cargoGrid": "Rejilla de carga",
        "shipInventory": "Inventario de la nave",
        "remaining": "Restante",
        "unmeasured": "%{count} sin medir todavía"
      },
      "hangarInventories": "Inventories",
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "slot": "Slot",
        "size": "Size",
        "grade": "Grade",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      }
    }
  }
}
